import { FC } from 'react';
import { FormProvider } from 'react-hook-form';
import { Col } from 'react-styled-flexboxgrid';

import { BUTTON_TYPES } from '@savgroup-front-common/constants';
import { ActionRow } from '@savgroup-front-common/core/atoms/ActionRow';
import { Button } from '@savgroup-front-common/core/atoms/button';
import { Card } from '@savgroup-front-common/core/atoms/Cards';
import {
  CollectBankAccountDetailsForm,
  useCollectBankAccountDetailsForm,
} from '@savgroup-front-common/core/components/CollectBankAccountDetailsForm';
import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';
import { BannersConsumer } from '@savgroup-front-common/core/molecules/NotificationsProvider';
import { CheckIcon } from '@savgroup-front-common/core/protons/icons';

import messages from './messages';

interface CollectBankAccountDetailsProps {
  fileId: string;
  isLoading?: boolean;
  onSubmit: () => void;
}

const CollectBankAccountDetails: FC<CollectBankAccountDetailsProps> = ({
  fileId,
  isLoading = false,
  onSubmit,
}) => {
  const { handleSubmitCollectBankAccountDetails, formContext } =
    useCollectBankAccountDetailsForm({
      fileId,
      onUpsertSuccess: onSubmit,
    });
  const {
    formState: { isSubmitting, errors },
  } = formContext;

  return (
    <Card>
      <FormProvider {...formContext}>
        <form onSubmit={handleSubmitCollectBankAccountDetails}>
          <BannersConsumer />

          <CollectBankAccountDetailsForm />

          <ActionRow>
            <Col xs={12} sm>
              <Button
                primary
                type={BUTTON_TYPES.SUBMIT}
                isLoading={isLoading || isSubmitting}
                isError={Object.keys(errors).length > 0}
                icon={<CheckIcon />}
                dataTestId="submitButton"
              >
                <SafeFormattedMessageWithoutSpread
                  message={messages.validate}
                />
              </Button>
            </Col>
          </ActionRow>
        </form>
      </FormProvider>
    </Card>
  );
};

CollectBankAccountDetails.displayName = 'CollectBankAccountDetails';

export default CollectBankAccountDetails;
